import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { Section } from "../components/Section";
import { Seo } from "../components/Seo";
import { SocialShare } from "../components/SocialShare";
import { NewsItem, getNewsItem } from "../data/news";

export function NewsArticle() {
  const { id = "" } = useParams();
  const [item, setItem] = useState<NewsItem | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getNewsItem(id)
      .then(setItem)
      .catch(() => setItem(null))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <>
        <Seo title="News" description="Loading school news from Zion Classical Academy." path={`/news/${id}`} />
        <PageHeader eyebrow="News" title="Loading update">
          Please wait while this update loads.
        </PageHeader>
      </>
    );
  }

  if (!item) {
    return (
      <>
        <Seo title="News update not found" description="This Zion Classical Academy news update is not available." path={`/news/${id}`} />
        <PageHeader eyebrow="News" title="Update not found">
          This update may have expired or is no longer published.
        </PageHeader>
        <Section title="News">
          <Link className="button button-secondary" to="/news">View all news</Link>
        </Section>
      </>
    );
  }

  const articlePath = `/news/${item.id}`;

  return (
    <>
      <Seo title={item.title} description={item.summary || "School news from Zion Classical Academy."} path={articlePath} />
      <PageHeader eyebrow={item.urgent ? "Urgent Update" : item.category} title={item.title}>
        {item.summary || "School news from Zion Classical Academy."}
      </PageHeader>
      <Section title="Update">
        <article className="list-item news-detail">
          <p className="eyebrow">
            {item.urgent ? "Urgent - " : ""}
            {item.category} - {item.date ? new Date(item.date).toLocaleDateString() : "Recent"}
          </p>
          {item.body ? <p>{item.body}</p> : null}
          {item.linkUrl ? <a className="text-link" href={item.linkUrl}>Open link</a> : null}
          {item.attachments?.length ? (
            <div className="attachment-list">
              {item.attachments.map((attachment) => (
                attachment.downloadUrl ? (
                  <a key={attachment.id} href={attachment.downloadUrl}>{attachment.name}</a>
                ) : (
                  <span key={attachment.id}>{attachment.name}</span>
                )
              ))}
            </div>
          ) : null}
          <SocialShare title={item.title} path={articlePath} />
        </article>
        <div style={{ marginTop: 18 }}>
          <Link className="button button-secondary" to="/news">All News</Link>
        </div>
      </Section>
    </>
  );
}
